<template lang="html">
  <div class="ModalSignup hidden" id="ModalSignup">
    <div @click="close" class="closer"></div>
    <div class="window">
      <h2>Don't miss it</h2>
      <p>Registration is not yet open — please <a href="http://eepurl.com/gRETMT" class="subscribe-link" title="link to subscription form">subscribe</a> to get notified, when it's available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalSignup',
  props: [],
  components: {
  },
  methods: {
    close: () => {
      // document.body.style.overflow = "";
      document.querySelector('#ModalSignup').classList.add("hidden");
    }
  },
  data: function() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
}
</script>

<style lang="css" scoped>
.ModalSignup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.window {
  position: relative;
  margin: auto;
  padding: 2.5rem 3rem;
  top: 6rem;
  width: 35%;
  /* background-color: #81a2b5; */
  background-color: rgb(0, 90, 200);
  color: #fff;
  box-shadow: 0 0.5rem 3rem rgba(0, 0, 0, 0.8);
  border-radius: 01rem;
}
.closer {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
p {
  margin-bottom: 1rem;
}
.subscribe-link {
  background-color: rgb(232, 162, 57);
}
.subscribe-link,
.subscribe-link:visited {
  color: #000;
}
.subscribe-link:hover,
.subscribe-link:visited:hover {
  background-color: #fff;
  color: rgb(201, 24, 0);
}
</style>
